import { gql } from 'graphql-tag';

export const GET_LABELS_FOR_MODEL = gql`
  query GetLabelsForModel($labelableType: String!, $labelableId: ID!) {
    labelsForModel(labelableType: $labelableType, labelableId: $labelableId) {
      id
      labelId
      labelableType
      labelableId
      label {
        id
        name
        slug
        color
      }
      createdAt
      updatedAt
    }
  }
`;
